import { Link as IParqueLink } from "iparque-components";
import React from "react";
import { LinkProps } from "react-router-dom";
import { RouterLink, StyledLinkProps } from "./styles";

interface Props extends Partial<LinkProps>, Partial<StyledLinkProps> {
  ariaLabel?: string;
  href?: string;
}

const Link: React.FC<Props> = ({
  to,
  ariaLabel,
  underline = "always",
  target = "_blank",
  className = "",
  rel = "noopener",
  children,
  href,
  ...props
}) => {
  return to ? (
    <RouterLink
      to={to}
      underline={underline}
      rel={rel}
      className={className}
      {...props}
    >
      {children}
    </RouterLink>
  ) : (
    <IParqueLink
      underline={underline}
      target={target}
      aria-label={ariaLabel}
      rel={rel}
      href={href}
      className={className}
      {...props}
    >
      {children}
    </IParqueLink>
  );
};

export default Link;
